import "./App.css";
import {
    BrowserRouter as Router,
    Routes,
    Route,
} from "react-router-dom";

import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";

import Home from "./pages/home/Home";
import About from "./pages/about/About";
import Contact from "./pages/contact/Contact";
import PrivacyPolicy from "./pages/legal/PrivacyPolicy";
import CookiesPolicy from "./pages/legal/CookiesPolicy";
import InvestAfricaPage from "./pages/invest-africa/InvestAfricaPage";

function App() {
    return (
        <Router>
            <ScrollToTop />

            <div className="app">
                <Header />

                <main className="app__main">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                        <Route path="/cookies-policy" element={<CookiesPolicy />} />
                        <Route path="/invest-africa" element={<InvestAfricaPage/>} />
                    </Routes>
                </main>

                <Footer />
            </div>
        </Router>
    );
}

export default App;